/** External links shown in the header/footer (ADR-0016 §1). Centralized so they never drift. */
export const EXTERNAL_LINKS = {
  github: 'https://github.com/fsantibanezleal/CAOS_GEOLAB',
  personal: 'https://fsantibanezleal.github.io',
  portfolio: 'https://fasl-work.com',
} as const;
